import React from 'react';
import styles from './index.module.scss';

const MashControlBadge = () => <span className={styles.badge}>C</span>;

export default MashControlBadge;
